import { lazy } from 'react';

const CustomTicketingTreball = lazy(() => import('./CustomTicketingTreball'));

export default CustomTicketingTreball;
